<template>
  <div
    v-if="
      isLogin ||
      isForgotPassword ||
      isChangePharmacy ||
      isSignicatVerify ||
      isVerifyBankID ||
      isVerifiedUser ||
      isPaymentSMS ||
      isAuthenticateCallerSMS ||
      isPickupPinQR ||
      isAuthenticationRegister ||
      isStrongAuthenticationRegister ||
      isLocationNotAllowed ||
      isPaymentFailed ||
      isPaymentSuccess ||
      isWelcomeToPharmacy ||
      isAppRedirect
    "
    class="loginPage"
  >
    <router-view />
  </div>
  <div
    v-if="
      !isLogin &&
      !isForgotPassword &&
      !isChangePharmacy &&
      !isSignicatVerify &&
      !isVerifyBankID &&
      !isPaymentSMS &&
      !isVerifiedUser &&
      !isAuthenticateCallerSMS &&
      !isPickupPinQR &&
      !isAuthenticationRegister &&
      !isStrongAuthenticationRegister &&
      !isLocationNotAllowed &&
      !isPaymentFailed &&
      !isPaymentSuccess &&
      !isWelcomeToPharmacy &&
      !isAppRedirect
    "
    class="appShell"
  >
    <InfoBanner variant="bar" />
    <div class="main">
      <Sidebar v-if="!navigation" />
      <div class="page">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';
import { firebaseApp } from './firebase/firebaseInit';

import Sidebar from './views/partial/Sidebar.vue';

import '@/reset.scss';
import router, { isCypressEnv } from './router';

@Options({
  name: 'Home',
  components: {
    Sidebar
  },
  data: () => {
    return {
      navigation: null
    };
  },
  created() {
    this.checkRoute(this.$route.name);

    if (this.$route.name) {
      if (
        (firebaseApp.auth().currentUser || isCypressEnv()) &&
        (this.isNotSignicatVerify ||
          this.isNotVerifyBankID ||
          this.isNotPaymentSMS)
      ) {
        this.getUserProfile();
      }
    }

    if (window.location.pathname === '/') {
      router.push({ name: 'Login' });
    }
  },
  computed: {
    isNotSignicatVerify() {
      return !window.location.pathname.includes('verif');
    },
    isNotVerifyBankID() {
      return !window.location.pathname.includes('authenticat');
    },
    isNotPaymentSMS() {
      return !(
        window.location.pathname === 'pay' &&
        window.location.search.includes('data=')
      );
    },
    isLogin() {
      return this.$route.name === 'Login';
    },
    isForgotPassword() {
      return this.$route.name === 'ForgotPassword';
    },
    isChangePharmacy() {
      return this.$route.name === 'ChangePharmacy';
    },
    isSignicatVerify() {
      return this.$route.name === 'SignicatVerify';
    },
    isVerifyBankID() {
      return this.$route.name === 'VerifyBankID';
    },
    isPaymentSMS() {
      return this.$route.name === 'PaymentSMS';
    },
    isVerifiedUser() {
      return this.$route.name === 'VerifiedUser';
    },
    isAuthenticateCallerSMS() {
      return this.$route.name === 'AuthenticateCallerSMS';
    },
    isPickupPinQR() {
      return this.$route.name === 'PickupPinQR';
    },
    isAuthenticationRegister() {
      return this.$route.name === 'AuthenticationRegister';
    },
    isStrongAuthenticationRegister() {
      return this.$route.name === 'StrongAuthenticationRegister';
    },
    isLocationNotAllowed() {
      return this.$route.name === 'LocationNotAllowed';
    },
    isPaymentFailed() {
      return this.$route.name === 'PaymentFailed';
    },
    isPaymentSuccess() {
      return this.$route.name === 'PaymentSuccess';
    },
    isWelcomeToPharmacy() {
      return this.$route.name === 'WelcomeToPharmacy';
    },
    isAppRedirect() {
      return this.$route.name === 'AppRedirect';
    }
  },
  methods: {
    ...mapActions('account', ['getUserProfile']),
    checkRoute(): boolean {
      return (
        this.$route.name === 'Login' ||
        this.$route.name === 'ForgotPassword' ||
        this.$route.name === 'ChangePharmacy' ||
        this.$route.name === 'NotFound' ||
        this.$route.name === 'LocationNotAllowed'
      );
    }
  },
  watch: {
    $route(): void {
      this.navigation = this.checkRoute();
    }
  }
})
export default class App extends Vue {}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $dark-blue;
  margin: 0 auto;
  height: 100%;
  min-height: 100%;
}

* {
  font-family: 'Ubuntu-Regular';
  background-color: $white;
  color: $main-text;
  margin: 0;
}

.error {
  text-align: center;
  font-size: $twelveSize;
  color: $dark-grey;
}

.main {
  display: flex;
}

.page {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
}

// The info bar sits above everything, so the sidebar and the page share what
// is left of the viewport instead of each claiming the full height.
.appShell {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .main {
    flex: 1;
    min-height: 0;
  }
  .page,
  .sidebar,
  .sidebar__container {
    height: 100%;
  }
}
</style>
